module.exports = __webpack_public_path__ + "img/logo.4de1cbf6.png";